import moment from 'moment-timezone';
import { Col } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import hasPermission from '../../../../Shared/hasPermission';

const SyncDate = () => {
    const dispatch = useDispatch();
    const { hasScheduleIssue, nextSyncDate, practiceId } = useSelector(
        (state) => {
            const { hasScheduleIssue, nextSyncDate, id } =
                state.practice.practice;
            return { hasScheduleIssue, nextSyncDate, practiceId: id };
        },
        shallowEqual
    );
    
    const openScheduleModal = () => {
        dispatch(
            actions.practice.setPracticeScheduleModalWorkingPractice({ nextSyncDate, id:practiceId })
        );
        dispatch(actions.toggle.togglePracticeScheduleModal(true));
    };

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canSyncScheduling = hasPermission(`SyncScheduling`, permissions);

    let title = 'Next Sync Date';
    let colSytle = 'd-flex px-3 py-2';
    let spanStyle;
    let iconStyle;
    if (hasScheduleIssue) {
        title += ' (Past due)';
        spanStyle = 'px-1 bg-danger rounded';
    }
    let colProps = {
        md: 12,
        title,
    };
    if (canSyncScheduling) {
        colSytle += ' hover-parent hoverable';
        colProps['onClick'] = openScheduleModal;
        spanStyle += ' hoverable config-item';
        iconStyle = 'underline-on-hover';
    }
    colProps['className'] = colSytle;

    const syncDate = nextSyncDate ? moment.unix(nextSyncDate).local() : Date.now();
    const syncDateText = nextSyncDate 
        ? syncDate.format('M/D/YYYY LT') + ' ' + moment.tz(moment.tz.guess()).zoneAbbr()
        : 'No Sync Date Set';

    return (
        <Col {...colProps}>
            <span className={iconStyle}>
                <FontAwesomeIcon
                    className="text-light op-6"
                    icon={faCalendarDay}
                    size="lg"
                />
                &emsp;
                <span className={spanStyle}>{syncDateText}</span>
            </span>
        </Col>
    );
};

export default SyncDate;
